import { Component, OnInit, OnDestroy, ViewChild, Input } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { SalesOrder, UiSoOrder, UiSummarySO, SubSalesOrder, FunctionStatus, SOStatus, SSOStatus, monthFilter, MarketingEngineer, userFilterOption, UiReviewSO, CommentsPR, PmTechnicalIP } from '../shared/misc-classes';
import { GenService } from '../shared/gen-ser.service';
import { saleOrderPipe } from '../filters/saleorder.pipe';
import * as XLSX from 'xlsx';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-review-page',
  templateUrl: './review-page.component.html',
  styleUrls: ['./review-page.component.css']
})
export class ReviewPageComponent implements OnInit {

    @Input() pmTechSSO: PmTechnicalIP;
    soObj: SalesOrder;
    _soObjList1: Array<SalesOrder>;
  
    // @ViewChild('userImpForm') userImpFrm;
  
    _saleOrderArray1: Array<UiReviewSO> = [];
    _selectedCustomer1: any;
  
    _filterPipe: saleOrderPipe = new saleOrderPipe();
    search1: string='';
    serialSearch1: string='';
    filteredSaleOrderArray1: Array<UiReviewSO> = [];
    filteredSOCount1:number = 0;
    filteredSSOCount1:number = 0;
    filteredQuantity1:number = 0;
    filteredPOValue1:number = 0;
    filteredCustPOVal1:number = 0;
    filteredAmmendPOVal1:number =0;
    isDataViewUpdated1:boolean = false;
    filteredPOValue1_temp:number = 0;
    filteredCustPOVal1_temp:number = 0;
    filteredAmmendPOVal1_temp:number =0;
    unitName:string='minr'
  
    isLoading1: boolean = false;
  
    _uiObj: any = [];
  
    isRevMonthFilterSelected1:boolean = false;
    isInvMonthFilterSelected1:boolean = false;
    isManfMonthFilterSelected1:boolean = false;
    isManfStrategyFilterSelected1:boolean = false;
    isOrderTypeFilterSelected1: boolean = false;
    isRegionFilterSelected1: boolean = false;
    isRelayConfigFilterSelected1:boolean = false;
    isUserSelectionFilterSelected1:boolean = false;
    userSelectionType1:userFilterOption = userFilterOption.All;
    userDeptIdSelected1:string[]= [];
    revMonthFilter1:monthFilter;
    InvMonthFilter1:monthFilter;
    manfMonthFilter1:monthFilter;
    manfStrategyIndex1:number = 0;
    orderTypeIndex1: number= 0;
    regionIndex1: number= 0;
    relayConfigIndex1: number= 0;
    orderStatusId1:string = "0";
    variantTypeId1:string = "0";
    quantityTypeId1:string = "0";
    regionSelToken1:string = "0,0"; 

    // Table filters
    HOMFilter:number = 0;
    SldGtpFilter:number = 0;
    GaCsFilter:number = 0;
    SchemeFilter:number = 0;
    MgaFilter:number = 0;
    SldGaGtpFilter: number = 0;
    LngLeadFilter:number = 0;
    FinDrgFilter:number = 0;
    CtTechFilter:number = 0;
    FcmCTFilter:number = 0;
    CtFinalFilter:string = "0";
    C40Filter:number = 0;
    C50Filter:number = 0;
    C60Filter:number = 0;
    RelayRcptFilter:number = 0;
    CtRcptFilter:string = "0";
    MbRcptFilter:string = "0";
    LineLdngFilter:string = "0";
    CbRcptFilter:number = 0;
    MechStkrFilter:number = 0;
    IntrnlTstFilter:number = 0;
    FATFilter:number = 0;
    GreenStkrFilter:number = 0;
    ExWrksFilter: number = 0;
    DaysReqFilter:string = "0";
    marketingEnggArray1:string[]= [];
    projManagerArray1:string[]= [];
    projEnggArray1:string[]= [];
    elecDesignEnggArray1:string[]= [];
    mechDesignEnggArray1:string[]= [];
    c30EnggArray1:string[]= [];
    userTypeArray1:any[]= [];

    _comnts:string;
    _SSoNo:string = "0";

    _dataObj1:any = {};
    
    constructor(public _dataService1: DataService, private _genService: GenService, public dialog: MatDialog) { }
  
    ngOnInit() {
      try{
        this.loadSettingsFromCookies();
      }catch(e){
        console.log(e);
      }
      
  
      this.loadData();
    }
    saveSettingsToCookies(){
      this._dataService1.setCookie('s-search1', this.search1);
      this._dataService1.setCookie('s-search1-serial', this.serialSearch1);
      this._dataService1.setCookie('s-revmonth-sel1', this.isRevMonthFilterSelected1 ? "1":"0");
      if(this.isRevMonthFilterSelected1){
        this._dataService1.setCookie('s-revmonth-val1', this.revMonthFilter1.getCookieStr());
      }
      this._dataService1.setCookie('s-invoicingmonth-sel1', this.isInvMonthFilterSelected1 ? "1":"0");
      if(this.isInvMonthFilterSelected1){
        this._dataService1.setCookie('s-invoicingmonth-val1', this.InvMonthFilter1.getCookieStr());
      }
      this._dataService1.setCookie('s-manfmonth-sel1', this.isManfMonthFilterSelected1 ? "1":"0");
      if(this.isManfMonthFilterSelected1){
        this._dataService1.setCookie('s-manfmonth-val1', this.manfMonthFilter1.getCookieStr());
      }
      this._dataService1.setCookie('s-manfstra-sel1', this.isManfStrategyFilterSelected1 ? "1":"0");
      if(this.isManfStrategyFilterSelected1){
        this._dataService1.setCookie('s-manfstra-val1', this.manfStrategyIndex1 + '');
      }
      this._dataService1.setCookie('s-userdept-sel1', this.isUserSelectionFilterSelected1 ? "1":"0")
      if(this.isUserSelectionFilterSelected1){
        this._dataService1.setCookie('s-userdept-val1', this.userDeptIdSelected1 + '')
      }
      this._dataService1.setCookie('s-ordertype-sel1', this.isOrderTypeFilterSelected1 ? "1":"0");
      if(this.isOrderTypeFilterSelected1){
        this._dataService1.setCookie('s-ordertype-val1', this.orderTypeIndex1 + '');
      }
      this._dataService1.setCookie('s-relayconfig-sel1', this.isRelayConfigFilterSelected1 ? "1":"0");
      if(this.isRelayConfigFilterSelected1){
        this._dataService1.setCookie('s-relayconfig-val1', this.relayConfigIndex1 + '');
      }
      this._dataService1.setCookie('s-region-sel1', this.isRegionFilterSelected1 ? "1":"0");
      if(this.isRegionFilterSelected1){
        // this._dataService1.setCookie('s-region-val', this.regionIndex1 + '');
        this._dataService1.setCookie('s-region-val1', this.regionSelToken1);
      }
  
      this._dataService1.setCookie('s-table-opts1', 
          `${this.variantTypeId1},${this.quantityTypeId1},${this.HOMFilter},${this.SldGtpFilter},
          ${this.GaCsFilter},${this.SchemeFilter},${this.MgaFilter},${this.SldGaGtpFilter},${this.LngLeadFilter},${this.FinDrgFilter},
          ${this.CtTechFilter},${this.FcmCTFilter},${this.CtFinalFilter},${this.C40Filter},${this.C50Filter},${this.C60Filter},
          ${this.RelayRcptFilter},${this.CtRcptFilter},${this.MbRcptFilter},${this.LineLdngFilter},${this.CbRcptFilter},${this.MechStkrFilter},
          ${this.IntrnlTstFilter},${this.FATFilter},${this.GreenStkrFilter},${this.ExWrksFilter},${this.DaysReqFilter},${this.orderStatusId1}`);
          
    }
    loadSettingsFromCookies(){
      let _tmpSearch1:string = this._dataService1.getCookie('s-search1');
      if(_tmpSearch1){
        this.search1 = _tmpSearch1;
      }
      let _tmpSerialSearch1: string = this._dataService1.getCookie('s-search1-serial');
      if (_tmpSerialSearch1) {
        this.serialSearch1 = _tmpSerialSearch1;
      }
      let _tmpRevMonthSel:string = this._dataService1.getCookie('s-revmonth-sel1');
      if(_tmpRevMonthSel){
        this.isRevMonthFilterSelected1 = (_tmpRevMonthSel == "1");
  
        let _tmpRevMonthVal:string = this._dataService1.getCookie('s-revmonth-val1');
        if(_tmpRevMonthVal){
          this.revMonthFilter1 = monthFilter.getObjFromCookieStr(_tmpRevMonthVal);
        }
      }
      let _tmpInvMonthSel:string = this._dataService1.getCookie('s-invoicingmonth-sel1');
      if(_tmpInvMonthSel){
        this.isInvMonthFilterSelected1 = (_tmpInvMonthSel == "1");
  
        let _tmpInvMonthVal:string = this._dataService1.getCookie('s-invoicingmonth-val1');
        if(_tmpInvMonthVal){
          this.InvMonthFilter1 = monthFilter.getObjFromCookieStr(_tmpInvMonthVal);
        }
      }
      let _tmpManfMonthSel:string = this._dataService1.getCookie('s-manfmonth-sel1');
      if(_tmpManfMonthSel){
        this.isManfMonthFilterSelected1 = (_tmpManfMonthSel == "1");
  
        let _tmpManfMonthVal:string = this._dataService1.getCookie('s-manfmonth-val1');
        if(_tmpManfMonthVal){
          this.manfMonthFilter1 = monthFilter.getObjFromCookieStr(_tmpManfMonthVal);
        }
      }
      let _tmpManfStraSel:string = this._dataService1.getCookie('s-manfstra-sel1');
      if(_tmpManfStraSel){
        this.isManfStrategyFilterSelected1 = (_tmpManfStraSel == "1");
  
        let _tmpManfStraVal:string = this._dataService1.getCookie('s-manfstra-val1');
        if(_tmpManfStraVal){
          this.manfStrategyIndex1 = parseInt(_tmpManfStraVal , 10);
        }
      }
      let _tmpUserDeptSel:string = this._dataService1.getCookie('s-userdept-sel1');
      if(_tmpUserDeptSel){
        this.isUserSelectionFilterSelected1 = (_tmpUserDeptSel == "1");
  
        let _tmpUserDeptVal:string = this._dataService1.getCookie('s-userdept-val1');
        if(_tmpUserDeptVal){ 
          this.userDeptIdSelected1 = _tmpUserDeptVal.split(",");
          this.extractUserDeptSelToken1(_tmpUserDeptVal.split(","));
        }
      }
      let _tmpOrderTypeSel:string = this._dataService1.getCookie('s-ordertype-sel1');
      if(_tmpOrderTypeSel){
        this.isOrderTypeFilterSelected1 = (_tmpOrderTypeSel == "1");
  
        let _tmpOrderTypeVal:string = this._dataService1.getCookie('s-ordertype-val1');
        if(_tmpOrderTypeVal){
          this.orderTypeIndex1 = parseInt(_tmpOrderTypeVal , 3);
        }
      }
      let _tmpRelayConfigSel:string = this._dataService1.getCookie('s-relayconfig-sel1');
      if(_tmpRelayConfigSel){
        this.isRelayConfigFilterSelected1 = (_tmpRelayConfigSel == "1");
  
        let _tmpRelayConfigVal:string = this._dataService1.getCookie('s-relayconfig-val1');
        if(_tmpRelayConfigVal){
          this.relayConfigIndex1 = parseInt(_tmpRelayConfigVal , 10);
        }
      }
      let _tmpRegionSel:string = this._dataService1.getCookie('s-region-sel1');
      if(_tmpRegionSel){
        this.isRegionFilterSelected1 = (_tmpRegionSel == "1");
  
        let _tmpRegionVal:string = this._dataService1.getCookie('s-region-val1');
        if(_tmpRegionVal){
          // this.regionIndex1 = parseInt(_tmpRegionVal , 10);
          this.extractRegionSelToken(_tmpRegionVal, true);
        }
      }
      let _tmpTableOptions:string = this._dataService1.getCookie('s-table-opts1');
      if(_tmpTableOptions){
        let _optTokens:Array<string> = _tmpTableOptions.split(',');

      if(_optTokens.length >= 27){
        if(_optTokens[27]){
          this.orderStatusId1 = _optTokens[27];
        }
          this.variantTypeId1 = _optTokens[0];
          this.quantityTypeId1 = _optTokens[1];

          this.HOMFilter = parseInt(_optTokens[2],10);
          this.SldGtpFilter = parseInt(_optTokens[3],10);
          this.GaCsFilter = parseInt(_optTokens[4],10);
          this.SchemeFilter = parseInt(_optTokens[5],10);
          this.MgaFilter = parseInt(_optTokens[6],10);
          this.SldGaGtpFilter = parseInt(_optTokens[7],10);
          this.LngLeadFilter = parseInt(_optTokens[8],10);
          this.FinDrgFilter = parseInt(_optTokens[9],10);
          this.CtTechFilter = parseInt(_optTokens[10],10);
          this.FcmCTFilter = parseInt(_optTokens[11],10);
          this.CtFinalFilter = _optTokens[12]
          this.C40Filter = parseInt(_optTokens[13],10);
          this.C50Filter = parseInt(_optTokens[14],10);
          this.C60Filter = parseInt(_optTokens[15],10);
          this.RelayRcptFilter = parseInt(_optTokens[16],10);
          this.CtRcptFilter = _optTokens[17]
          this.MbRcptFilter = _optTokens[18];
          this.LineLdngFilter = _optTokens[19]
          this.CbRcptFilter = parseInt(_optTokens[20],10);
          this.MechStkrFilter = parseInt(_optTokens[21],10);
          this.IntrnlTstFilter = parseInt(_optTokens[22],10);
          this.FATFilter = parseInt(_optTokens[23],10);
          this.GreenStkrFilter = parseInt(_optTokens[24],10);
          this.ExWrksFilter = parseInt(_optTokens[25],10);
          this.DaysReqFilter = _optTokens[26];
          
          
         
       }
      }
  
      let _currDate:Date = new Date();
      if(this.revMonthFilter1 == null){
        this.revMonthFilter1 = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
        _currDate.getMonth()+1, _currDate.getFullYear());
      }
      if(this.InvMonthFilter1 == null){
        this.InvMonthFilter1 = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
        _currDate.getMonth()+1, _currDate.getFullYear());
      }
      if(this.manfMonthFilter1 == null){
        this.manfMonthFilter1 = new monthFilter(_currDate.getMonth()+1, _currDate.getFullYear(),
        _currDate.getMonth()+1, _currDate.getFullYear());
      }
    }
    loadData() {
      this.isLoading1 = true;
      this._dataService1.getDataDefinitions().subscribe(res => {
        this._dataService1.getAllSalesOrder_PR(1).subscribe((_soObjAr1:Array<SalesOrder>) => {
          this._soObjList1 = _soObjAr1.filter((_tmpSO1:SalesOrder) => {
            //test the filter.
            // if(_tmpSO1.projectStatus == SOStatus.Dispatched || _tmpSO1.projectStatus == SOStatus.Archived)
            if(_tmpSO1.projectStatus == SOStatus.Dispatched)
            {
              return false;
            }
            return true;
          });
          this.filterRows();
        });
      });
    }

    getClassName(_temp: number): string {
      if (_temp < 6) {
        return "bg-grey";
      } else if (_temp >= 6 && _temp < 10) {
        return "bg-yellow";
      } else if (_temp > 10) {
        return "bg-green";
      }
    }
   

    expandCollapseRow(_row: any) {
      if (_row.showSSo == false) {
        _row.showSSo = true;
        for (var i = 0; i < this._saleOrderArray1.length; i++) {
          if (this._saleOrderArray1[i].type == 'sso' && this._saleOrderArray1[i].soId == _row.soId) {
            this._saleOrderArray1[i].showRow = true;
          }
        }
      }
      else {
        _row.showSSo = false;
        for (var i = 0; i < this._saleOrderArray1.length; i++) {
          if (this._saleOrderArray1[i].type == 'sso' && this._saleOrderArray1[i].soId == _row.soId) {
            this._saleOrderArray1[i].showRow = false;
          }
        }
      }
    }
  
    reloadData(): void {
      this.isLoading1 = true;
      this.loadData();
    }
    clearFilters(): void{
      this.search1 = '';
      this.serialSearch1 = '';
      this.isRevMonthFilterSelected1 = false;
      this.isInvMonthFilterSelected1 = false;
      this.isManfMonthFilterSelected1 = false;
      this.isManfStrategyFilterSelected1 = false;
      this.isUserSelectionFilterSelected1 = false;
      this.isOrderTypeFilterSelected1 = false;
      this.isRegionFilterSelected1 = false;
      this.isRelayConfigFilterSelected1 = false;
      //this.userDeptSelToken1 = "0,0,0"; 
      //this.userSelectionType1 = userFilterOption.All;
      //this.userDeptIdSelected1 = "";
      this.orderTypeIndex1 = 0;
      // this.regionIndex1 = 0;
      this.relayConfigIndex1 =0;
      this.manfStrategyIndex1 = 0;
      this.orderStatusId1 = "0";
      this.variantTypeId1 = "0";
      this.quantityTypeId1 = "0"

      this.HOMFilter = 0;
      this.SldGtpFilter = 0;
      this.GaCsFilter = 0;
      this.SchemeFilter = 0;
      this.MgaFilter = 0;
      this.SldGaGtpFilter = 0;
      this.LngLeadFilter = 0;
      this.FinDrgFilter = 0;
      this.CtTechFilter = 0;
      this.FcmCTFilter = 0;
      this.CtFinalFilter = "0";
      this.C40Filter = 0;
      this.C50Filter = 0;
      this.C60Filter = 0;
      this.RelayRcptFilter = 0;
      this.CtRcptFilter = "0";
      this.MbRcptFilter = "0";
      this.LineLdngFilter = "0";
      this.CbRcptFilter = 0;
      this.MechStkrFilter = 0;
      this.IntrnlTstFilter = 0;
      this.FATFilter = 0;
      this.GreenStkrFilter = 0;
      this.ExWrksFilter = 0;
      this.DaysReqFilter = "0";
      this.userDeptIdSelected1 = [];
      this.userTypeArray1 = [];
      this.marketingEnggArray1 = [];
      this.projManagerArray1 = [];
      this.projEnggArray1 = [];
      this.elecDesignEnggArray1 = [];
      this.mechDesignEnggArray1 = [];
      this.c30EnggArray1 = [];
     
      
  
      this.isLoading1 = true;
      this.loadData();
  
      setTimeout(() => {
        this.saveSettingsToCookies();
      }, 10);
    }
  
    hideThisRow(_row) {
      // if (this._selectedCustomer1) {
      //    console.log(_row.custName + ',' + this._selectedCustomer1.label)
      // }
      return (this._selectedCustomer1 && (this._selectedCustomer1 == '' || _row.custName != this._selectedCustomer1));
    }
    extractUserDeptSelToken1(_tmpToken){
      let _tmpUserArray = [];
      let _tmpUserArrayUniq = [];
      let _tokens:Array<string> = _tmpToken;
      let _tmpmarketingEnggArray = [];
      let _tmpprojManagerArray = [];
      let _tmpprojEnggArray = [];
      let _tmpelecDesignEnggArray = [];
      let _tmpmechDesignEnggArray = [];
      let _tmpc30EnggArray = [];
  
      for(let i = 0; i<_tokens.length;i++){
          let _user = _tokens[i].split(':');
          let _userType:userFilterOption = userFilterOption.All;
          _userType =  parseInt(_user[0],10);        
          if(_userType == userFilterOption.MarketingEngineer){
           _tmpUserArray.push(_userType);
           _tmpmarketingEnggArray.push(_user[1]);
          }
          else if(_userType == userFilterOption.ProjectManager){
           _tmpUserArray.push(_userType);
           _tmpprojManagerArray.push(_user[1]);
          }
          else if(_userType == userFilterOption.ProjectEngineer){
           _tmpUserArray.push(_userType);
           _tmpprojEnggArray.push(_user[1]);
          }
          else if(_userType == userFilterOption.ElectricDesignEngineer){
           _tmpUserArray.push(_userType);
           _tmpelecDesignEnggArray.push(_user[1]);
          }
          else if(_userType == userFilterOption.MechanicalDesignEngineer){
           _tmpUserArray.push(_userType);
           _tmpmechDesignEnggArray.push(_user[1]);
          }
          else if(_userType == userFilterOption.C30Engineer){
           _tmpUserArray.push(_userType);
           _tmpc30EnggArray.push(_user[1]);
          }
          else if(_userType == userFilterOption.All){
            _tmpUserArray = [];
            _tmpUserArray.push(_userType);
          }
      }
  
      _tmpUserArray.forEach((item) => {  
        if(!_tmpUserArrayUniq.includes(item)){  
           _tmpUserArrayUniq.push(item);  
        }  
     }); 
     
     this.userTypeArray1 = _tmpUserArrayUniq;
     this.marketingEnggArray1 = _tmpmarketingEnggArray;
     this.projManagerArray1 = _tmpprojManagerArray
     this.projEnggArray1 = _tmpprojEnggArray;
     this.elecDesignEnggArray1 = _tmpelecDesignEnggArray;
     this.mechDesignEnggArray1 = _tmpmechDesignEnggArray;
     this.c30EnggArray1 = _tmpc30EnggArray;
    }
    userSelected(_event){
      this.extractUserDeptSelToken1(_event.value);
      this.filterRows();
  
    }
    extractRegionSelToken(_tmpToken:string, _updateSource:boolean):boolean{    
      let _tokens:Array<string> = _tmpToken.split(',');
       if(_tokens.length == 2 ){
         let regionType = parseInt(_tokens[0], 10); 
         //Comparing with 0 because 0 means 'All' category is are selected
         if(regionType != 0){
           this.regionIndex1 = parseInt(_tokens[1], 10);         
         }
         else this.regionIndex1 = 0; // TO SHOW ALL THE VALUES WHEN 'ALL' IS SELECTED
         if(_updateSource == true){
           this.regionSelToken1 =_tmpToken
         }
         return true;
       }
       return false;
    }
    regionSelected(){
        if(this.extractRegionSelToken(this.regionSelToken1, false)){
        this.filterRows();
    }
  }
    filterRows(): void {
      this.isLoading1 = true;
      setTimeout(() => {
        this.filterRowsLogic2();  
        this.isLoading1 = false;
      }, 5);
      this.saveSettingsToCookies();
    }
  
    private _searchKeyTimer:any;
    searchInputChanged(){
      if(this._searchKeyTimer){
        clearTimeout(this._searchKeyTimer);
      }
      this._searchKeyTimer = setTimeout(() => {
        this.filterRows();
      }, (this.search1.length < 5 || this.serialSearch1.length < 5 ? 700 : 500));
    }
  
    private displaySOwithNoSSO(){
      if(this.isRevMonthFilterSelected1 == true ||this.isInvMonthFilterSelected1 == true || this.isManfMonthFilterSelected1 == true || this.isManfStrategyFilterSelected1 == true || 
        this.isOrderTypeFilterSelected1 == true || this.isRelayConfigFilterSelected1 == true || 
        // this.isRegionFilterSelected1 == true || // COMMENTED BECAUSE THE TOTAL AMMED. PO VAL WAS DIFFEREING WHEN THE FILTER WAS APPLIED 
        this.userTypeArray1.includes(userFilterOption.ElectricDesignEngineer) ||
        this.userTypeArray1.includes(userFilterOption.MechanicalDesignEngineer) ||
        this.userTypeArray1.includes(userFilterOption.C30Engineer) ||
         this.orderStatusId1 != "0" || this.variantTypeId1 != "0" || this.quantityTypeId1 != "0" || this.HOMFilter != 0  || this.SldGtpFilter != 0 || this.GaCsFilter != 0 || this.SchemeFilter != 0 || this.MgaFilter != 0 ||
         this.SldGaGtpFilter != 0 || this.LngLeadFilter != 0 || this.FinDrgFilter != 0 || this.CtTechFilter != 0 || this.FcmCTFilter != 0 || this.CtFinalFilter != "0" ||
         this.C40Filter != 0 || this.C50Filter != 0 || this.C60Filter != 0 || this.RelayRcptFilter != 0 || this.CtRcptFilter != "0" || this.MbRcptFilter != "0" ||
         this.LineLdngFilter != "0" || this.CbRcptFilter != 0 || this.MechStkrFilter != 0 || this.IntrnlTstFilter != 0 || this.FATFilter != 0 || this.GreenStkrFilter != 0 || 
         this.ExWrksFilter != 0 || this.DaysReqFilter != "0" || this.serialSearch1 !=''
        
        ){
          return false;
        }
  
      return true;
    }
    
    filterRowsLogic2(){
      //console.log(1, (new Date()).getTime());
      let _tmpSaleOrderArray1: Array<UiReviewSO> = [];
      let _tmpSOCounter1: number = 0;
      let _tmpSSOCounter1: number = 0; 
      let _tmpCummQuantity1: number = 0;
      let _tmpCustPOValue1:number = 0;
      let _tmpCustPOVal1:number = 0;
      let _tmpAmmendPOVal1:number = 0;
      let _tmpUISoObj1:UiReviewSO;
      let _showSOWithNoSSO1:boolean = this.displaySOwithNoSSO();

      let _equpNeeded = [ "001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"]

      //  Filter the SSO for panels
      let _tmpArr =  this._soObjList1.map(function (Res) {
        Res.subSalesOrder.map(function (x) {
          x.pmTechSubSalesOrder.equipmentList = x.pmTechSubSalesOrder.equipmentList.filter(y => _equpNeeded.includes(y.equipmentType) == true)
        });
        return Res;
      }).filter(({ subSalesOrder }) => subSalesOrder);

      //  Filter the SSO for non empty equipment data
      let _tmpArr1 = _tmpArr.map(function (Res) {
        Res.subSalesOrder = Res.subSalesOrder.filter(x =>
          x.pmTechSubSalesOrder.equipmentList.length > 0);
        return Res;
      }).filter(({ subSalesOrder }) => subSalesOrder);

      // Remove the SO where there are no SSO with panels
      this._soObjList1 = _tmpArr1.filter(Res => Res.subSalesOrder.length !== 0);
  
      for (var i = 0; i < this._soObjList1.length; i++) {
        let _tmpSO1: SalesOrder = this._soObjList1[i];  
        
        let _isSOPassedFilter1:boolean = this.isSaleOrderTestPassed(_tmpSO1);
        if(_isSOPassedFilter1 == true){
          var _filteredSSO1:Array<SubSalesOrder> = this.getFilteredSubOrders(_tmpSO1.subSalesOrder);

          if(_filteredSSO1.length > 0 || (_tmpSO1.subSalesOrder.length == 0 && _showSOWithNoSSO1 == true)){
            //if there are any filtered sso or no actual sso at all(to accomodate new sales orders without suborders)
            //push so to output
            _tmpUISoObj1 = new UiReviewSO(_tmpSO1.salesOrderId, "so", _tmpSO1.marketingIP.salesOrderNo,
                                              "", _tmpSO1.marketingIP.customerName, "", "", true, false, (_tmpSO1.subSalesOrder.length == 0 ? true : false),
                                               _tmpSO1.projectStatus, 
                                              _tmpSO1.pmCommercial.isSaleOrderChangeApplicable, _tmpSO1.pmCommercial.salesOrderNoNew, null,null,
                                              _tmpSO1.marketingIP.homDate,null,null,null,null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,null,null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,
                                                null,         
                                                null,
                                                null,
                                                null,null,null
                                                ,null // TEST FOR COMMENTS,
                                                ,null,null
                                                );
                                              
            _tmpUISoObj1.subOrderCount = _filteredSSO1.length;
            _tmpSaleOrderArray1.push(_tmpUISoObj1);
            var _tmpValue1:number = parseFloat(_tmpSO1.pmCommercial.poAmmendmentValue);
            if(_tmpValue1){
              _tmpAmmendPOVal1 += _tmpValue1;
            }
             var _tmpVal1:number = parseFloat(_tmpSO1.marketingIP.customerPoValue);
             if(_tmpVal1>0 ){
              _tmpCustPOVal1 += _tmpVal1;
             }
             _tmpSOCounter1++;
            //push sso array to output
            
            let _tmpUISSoObj1:UiReviewSO;
            
            let _equpNeeded = [ "001", "002", "037", "003", "004", "005", "006", "007", "008", "009", "010", "011", "012", "013", "014", "015", "016", "017", "018"]
            

            _filteredSSO1.forEach((_tmpSSO1:SubSalesOrder) => {
            //   _tmpSSO1.pmTechSubSalesOrder.equipmentList.forEach((val)=>{
            //   if(!_equpNeeded.includes(val.equipmentType)){
            //     var indx = _tmpSSO1.pmTechSubSalesOrder.equipmentList.indexOf(val);
            //     // console.log("  _tmpSSO1.pmTechSubSalesOrder.equipmentList.indexOf(val)",  _tmpSSO1.pmTechSubSalesOrder.equipmentList.indexOf(val));
            //     _tmpSSO1.pmTechSubSalesOrder.equipmentList.splice(indx,1);      
                 
            //   }
            // });      
  
              _tmpUISSoObj1 = new UiReviewSO(_tmpSO1.salesOrderId, "sso",
                              _tmpSO1.marketingIP.salesOrderNo, _tmpSSO1.subOrderNoId, _tmpSO1.marketingIP.customerName,
                              this._dataService1.getProductVariantName(_tmpSSO1.pmTechSubSalesOrder.productVarient),
                              _tmpSSO1.pmTechSubSalesOrder.panelQuantity + '', true,
                              true, false,
                               _tmpSO1.projectStatus, false, "", _tmpSSO1.revenueMonth, _tmpSSO1.manufacturingMonth,_tmpSO1.marketingIP.homDate,_tmpSSO1.enggDrawIP.sldgtpSubDate, _tmpSSO1.enggDrawIP.gacsSubDate,
                              _tmpSSO1.enggDrawIP.schemeSubDate,_tmpSSO1.enggDrawIP.mgaSubDate,
                              _tmpSSO1.enggDrawIP.sldGaGtpAprvlDate ,
                              _tmpSSO1.enggProcureIP.longleadRDate ,
                              _tmpSSO1.pmTechSubSalesOrder.fnCusDrgAprvlDate ,
                              _tmpSSO1.enggDrawIP.techCTDetsDate,
                              _tmpSSO1.pmTechSubSalesOrder.fcmCTfinActDate ,
                              _tmpSSO1.scmIP.CTfinSCMActDate ,
                              _tmpSSO1.enggProcureIP.c40ActDate ,
                              _tmpSSO1.enggProcureIP.c50ActDate ,
                              _tmpSSO1.enggProcureIP.c60ActDate ,
                              _tmpSSO1.purchaseMatReceipt.relayRecpDate ,
                              _tmpSSO1.purchaseMatReceipt.ctRecpDate ,
                              _tmpSSO1.purchaseMatReceipt.ctRecpDateStatus ,
                              _tmpSSO1.purchaseMatReceipt.ctRecpApplicablity ,
                              _tmpSSO1.purchaseMatReceipt.mbRecpDate ,
                              _tmpSSO1.purchaseMatReceipt.mbRecpDateStatus ,
                              _tmpSSO1.purchaseMatReceipt.cbRecpDate ,
                              _tmpSSO1.productionIP.lineLoadActDate ,
                              _tmpSSO1.productionIP.lineLoadActDateStatus ,
                              _tmpSSO1.productionIP.mechStickerDate ,
                              _tmpSSO1.qualityIP.elecMechTestingDate ,
                              _tmpSSO1.qualityIP.FATDate ,
                              _tmpSSO1.qualityIP.greenStickerDate ,         
                              _tmpSSO1.pmTechSubSalesOrder.exWorksDate,
                              _tmpSSO1.pmTechSubSalesOrder.cursorIndex,
                              _tmpSSO1.pmTechSubSalesOrder.productLeadTimeDays,
                              _tmpSSO1.pmTechSubSalesOrder.daysReqPR
                              , _tmpSSO1.pmTechSubSalesOrder.commentsPR // TEST FOR COMMENTS
                              ,this._dataService1.getProjectEngineerName(_tmpSO1.pmCommercial.projectEngineerId), this._dataService1.getElecDesignEngineerName(_tmpSSO1.enggDrawIP.electricalDesignEngineerId)
                              );
  
                _tmpUISSoObj1.projExecStatus = _tmpSSO1.pmTechSubSalesOrder.projStatus;
                       
                _tmpSaleOrderArray1.push(_tmpUISSoObj1);
              
                if(_tmpSSO1.pmTechSubSalesOrder.panelQuantity > 0){

                  _tmpCummQuantity1 += _tmpSSO1.pmTechSubSalesOrder.panelQuantity;
                }
                var _contVal1:number = _tmpSSO1.pmTechSubSalesOrder.contractualValue;
                if(_contVal1>0){
                  _tmpCustPOValue1 += _contVal1;
                }
                // var _ammendVal:number = _tmpSSO1.pm
                _tmpSSOCounter1++;
            });
            if(_tmpUISSoObj1){
              _tmpUISSoObj1.islastSSo = true;
            }
            
         
          }
       
        }
      } 
  
      // if(_tmpUISoSummary){
      //   _tmpUISoSummary.islastSSo = true;
      // }
  
      this.filteredSaleOrderArray1 = _tmpSaleOrderArray1;
      
      
      this.filteredSOCount1 = _tmpSOCounter1;
      this.filteredSSOCount1 = _tmpSSOCounter1;
      this.filteredQuantity1 = _tmpCummQuantity1;
      this.filteredCustPOVal1 = _tmpCustPOVal1;
      this.filteredPOValue1 = _tmpCustPOValue1; ////////
      this.filteredAmmendPOVal1 = _tmpAmmendPOVal1;
      // For the unit convesions
      this.filteredCustPOVal1_temp = _tmpCustPOVal1;
      this.filteredPOValue1_temp = _tmpCustPOValue1;
      this.filteredAmmendPOVal1_temp = _tmpAmmendPOVal1;
  
      this.isDataViewUpdated1 = true;
      setTimeout(() => {
        this.isDataViewUpdated1 = false;
      }, 1000);
    }
    formatProductName(_fullProductName:string){
      if(_fullProductName.startsWith('UG ') == true){
        return _fullProductName.substring(3);
      }
      else if(_fullProductName.startsWith('LG ') == true){
        return _fullProductName.substring(3);
      }
      return _fullProductName;
    }
    getSaleOrderMessage():string{
      // if(this.isLoading == true) return '';
      // if(this.filteredSOCount1 == 0 && this.filteredSSOCount1 == 0) return 'no records.'
      return 'Displaying ' + this.filteredSOCount1 + ' sale order(s) with ' + this.filteredSSOCount1 +' sub order(s)';
    }
  
    getRevMonthLabel():string{
      if(this.isRevMonthFilterSelected1 == true){
        return "Revenue Month : ";
      }
      else{
        return "Enable Revenue Month Filter";
      }
    }
    getInvMonthLabel():string{
      if(this.isInvMonthFilterSelected1 == true){
        return "Invoicing Month : ";
      }
      else{
        return "Enable Invoicing Month Filter";
      }
    }
    getManfMonthLabel():string{
      if(this.isManfMonthFilterSelected1 == true){
        return "Manufacturing Month : ";
      }
      else{
        return "Enable Manufacturing Month Filter";
      }
    }
    getManfStrategyLabel():string{
      if(this.isManfStrategyFilterSelected1 == true){
        return "Manufacturing Strategy : ";
      }
      else{
        return "Enable Manufacturing Strategy Filter";
      }
    }
    getOrderTypeLabel():string{
      if(this.isOrderTypeFilterSelected1 == true){
        return "Order Type : "
      }
      else{
        return "Enable Order Type Filter"
      }
    }
    getRelayConfigLabel():string{
      if(this.isRelayConfigFilterSelected1 == true){
        return "Relay Configuration: "
      }
      else{
        return "Enable Relay Config. Filter"
      }
    }
    getRegionLabel():string{
      if(this.isRegionFilterSelected1 == true){
        return "Cluster - Region : "
      }
      else{
        return "Enable Cluster- Region Filter"
      }
    }
    getUserFilterLabel():string{
      if(this.isUserSelectionFilterSelected1 == true){
        return "User Selection : ";
      }
      else{
        return "Enable User Selection Filter";
      }
    }
    getOrderStatusFilterClass(_ordStatusId:string){
      if(_ordStatusId == 'live'){
        return 'clr-green';
      }
      else if(_ordStatusId == 'hold'){
        return  'yellow-back clr-red';
      }
      else if(_ordStatusId == 'cancel'){
        return 'clr-red';
      }
      return '';
    }
    getProductFilterClass(_typeId:string){
      if(_typeId != '0'){
        return 'filter-select red-option';
      }
      return 'filter-select';
    }

    getFilterClassPR(_opt:any){
      var _cls = '';
      if(_opt == 0){
        _cls = 'grey-option';
      }
      else if(_opt == 1){
        _cls =  'green-legend';
      }
      else if(_opt == 2){
        _cls = 'red-legend';
      }
      else if(_opt == 3){
        _cls = "yellow-legend";
      }
      else if(_opt == 4){
        _cls = "grey-legend";
      }
  
      return _cls +' filter-select';
    }
  
    getDaysReqClass(_days:number){
      var _cls = '';
      if(_days > 10){
        _cls = 'green-legend';
      }
      else if(_days >= 0 && _days <= 10){
        _cls = 'yellow-legend';
      }
      else if(_days < 0){
        _cls = 'red-legend';
      }
  
      return _cls;
    
    }
    getRevFromMonthName():string{
      if(this.revMonthFilter1){
        return this.revMonthFilter1.fromMonthName;
      }
      return '';
    }
    getRevToMonthName():string{
      if(this.revMonthFilter1){
        return this.revMonthFilter1.toMonthName;
      }
      return '';
    }
    getInvFromMonthName():string{
      if(this.InvMonthFilter1){
        return this.InvMonthFilter1.fromMonthName;
      }
      return '';
    }
    getInvToMonthName():string{
      if(this.InvMonthFilter1){
        return this.InvMonthFilter1.toMonthName;
      }
      return '';
    }
    getManfStrategyName():string{
      if(this.manfStrategyIndex1 >= 0 && this.manfStrategyIndex1 < this._dataService1.manufacturtingStrategy.length){
        return this._dataService1.manufacturtingStrategy[this.manfStrategyIndex1].manufacturtingStrategyName;
      }
      return '';
    }
    manfStrategyPrev(){
      if(this.manfStrategyIndex1 > 0){
        this.manfStrategyIndex1--;
      }
      else{
        this.manfStrategyIndex1 = this._dataService1.manufacturtingStrategy.length - 1;
      }
      this.filterRows();
    }
    manfStrategyNext(){
      if(this.manfStrategyIndex1 < this._dataService1.manufacturtingStrategy.length - 1){
        this.manfStrategyIndex1++;
      }
      else{
        this.manfStrategyIndex1 = 0;
      }
      this.filterRows();
    }
    getorderTypeName():string{
      if(this.orderTypeIndex1 >= 0 && this.orderTypeIndex1 < this._dataService1.ordertypes.length){
        return this._dataService1.ordertypes[this.orderTypeIndex1].ordertypeName;
      }
      return '';
    }
  
    orderTypePrev(){
      if(this.orderTypeIndex1 > 0){
        this.orderTypeIndex1--;
      }
      else{
        this.orderTypeIndex1 = this._dataService1.ordertypes.length - 1;
      }
      this.filterRows();
    }
    orderTypeNext(){
      if(this.orderTypeIndex1 < this._dataService1.ordertypes.length - 1){
        this.orderTypeIndex1++;
      }
      else{
        this.orderTypeIndex1 = 0;
      }
      this.filterRows();
    }
    getrelayConfigName():string{
      if(this.relayConfigIndex1 >= 0 && this.relayConfigIndex1 < this._dataService1.relayconfigs_ui.length){
        return this._dataService1.relayconfigs_ui[this.relayConfigIndex1].relayconfigName;
      }
      return '';
    }
  
    relayConfigPrev(){
      if(this.relayConfigIndex1 > 0){
        this.relayConfigIndex1--;
      }
      else{
        this.relayConfigIndex1 = this._dataService1.relayconfigs_ui.length - 1;
      }
      this.filterRows();
    }
    relayConfigNext(){
      if(this.relayConfigIndex1 < this._dataService1.relayconfigs_ui.length - 1){
        this.relayConfigIndex1++;
      }
      else{
        this.relayConfigIndex1 = 0;
      }
      this.filterRows();
    }
    
    getManfFromMonthName():string{
      if(this.manfMonthFilter1){
        return this.manfMonthFilter1.fromMonthName;
      }
      return '';
    }
    getManfToMonthName():string{
      if(this.manfMonthFilter1){
        return this.manfMonthFilter1.toMonthName;
      }
      return '';
    }
    revPrevFromMonth(){
      this.revMonthFilter1.prevFromMonth();
      this.filterRows();
    }
    revNextFromMonth(){
      this.revMonthFilter1.nextFromMonth();
      this.filterRows();
    }
    revPrevToMonth(){
      this.revMonthFilter1.prevToMonth();
      this.filterRows();
    }
    revNextToMonth(){
      this.revMonthFilter1.nextToMonth();
      this.filterRows();
    }
  
    InvPrevFromMonth(){
      this.InvMonthFilter1.prevFromMonth();
      this.filterRows();
    }
    InvNextFromMonth(){
      this.InvMonthFilter1.nextFromMonth();
      this.filterRows();
    }
    InvPrevToMonth(){
      this.InvMonthFilter1.prevToMonth();
      this.filterRows();
    }
    InvNextToMonth(){
      this.InvMonthFilter1.nextToMonth();
      this.filterRows();
    }
  
  
    manfPrevFromMonth(){
      this.manfMonthFilter1.prevFromMonth();
      this.filterRows();
    }
    manfNextFromMonth(){
      this.manfMonthFilter1.nextFromMonth();
      this.filterRows();
    }
    manfPrevToMonth(){
      this.manfMonthFilter1.prevToMonth();
      this.filterRows();
    }
    manfNextToMonth(){
      this.manfMonthFilter1.nextToMonth();
      this.filterRows();
    }
  
    private isSaleOrderTestPassed(_so:SalesOrder):boolean{
  
      //check sono and customer name in search
      if(this.isSONoCustSearchPassed(_so.marketingIP.salesOrderNo, _so.marketingIP.customerName, 
        _so.pmCommercial.isSaleOrderChangeApplicable, _so.pmCommercial.salesOrderNoNew, this.search1) == false) return false;
      
      //check if so user is seleceted
      if(this.isSOUserFilterPassed(_so.marketingIP.marketingEngineerId, _so.marketingIP.projectManagerId, _so.pmCommercial.projectEngineerId) == false) return false;
  
      //orderType filter
      if(this.isOrderTypeFilterPassed(_so.marketingIP.ordertypeId) == false) return false;
  
      //Cluster filter
      if(this.isRegionFilterPassed(_so.marketingIP.regionId) == false) return false;
  
      return true;
    }
    private getFilteredSubOrders(_ssoAr:Array<SubSalesOrder>):Array<SubSalesOrder>{
      return _ssoAr.filter((_sso:SubSalesOrder) => {
        //check for failure cases
        //dont show if sub order is dispatched
        if (_sso.isSSOStatusSet(SSOStatus.Dispatched) == true)  return false;
  
  
        //check if sso user is seleceted
        if(this.isSSOUserFilterPassed(_sso.enggDrawIP.electricalDesignEngineerId, _sso.enggDrawIP.mechanicalDesignEngineerId, _sso.enggDrawIP.c30EngineerId) == false) return false;
        
        //if a variant type selectde and it is not matching
        if(this.variantTypeId1 != "0"){
          if(this.variantTypeId1 != _sso.pmTechSubSalesOrder.productVarient)  return false;
          //Relay Config FIlter
      
        }
  
        //if a order status is selected and it is not matching
        if(this.orderStatusId1 != "0"){
          if(this.orderStatusId1 != _sso.pmTechSubSalesOrder.projStatus) return false;
        }
  
        //check if quantity type is selected then it matches
        if(this.quantityTypeId1 != "0"){        
          if(this.isQuantityTypeMatching(_sso.pmTechSubSalesOrder.panelQuantity) == false) return false;
        }

         //check if DaysReq filter is selected then it matches
         if(this.DaysReqFilter != "0"){        
          if(this.isDaysReqFiltered(_sso.pmTechSubSalesOrder.daysReqPR) == false) return false;
        }

        if(this.MbRcptFilter != "0"){        
          if(this.isPRFilterPassed_MBRecpt(_sso.purchaseMatReceipt.mbRecpDate,_sso.purchaseMatReceipt.mbRecpDateStatus) == false) return false;
        }

        if(this.LineLdngFilter != "0"){        
          if(this.isPRFilterPassed_LineLd(this.LineLdngFilter,_sso.productionIP.lineLoadActDate,_sso.productionIP.lineLoadActDateStatus) == false) return false;
        }

        if(this.CtFinalFilter != "0"){        
          if(this.isPRFilterPassed_CTfinal(_sso.scmIP.CTfinSCMActDate,_sso.scmIP.isInputEnabled) == false) return false;
        }

        if(this.CtRcptFilter != "0"){        
          if(this.isPRFilterPassed_CTRcpt(this.CtRcptFilter,_sso.purchaseMatReceipt.ctRecpDate,_sso.purchaseMatReceipt.ctRecpDateStatus,_sso.purchaseMatReceipt.ctRecpApplicablity) == false) return false;
        }
        // if(this.isPRFilterPassed(this.CtRcptFilter,_sso.purchaseMatReceipt.ctRecpDate)== false) return false;

        //check if revenue month 
        if(this.isRevMonthFilterPassed(_sso.revenueMonth) == false) return false;
        if(this.isInvMonthFilterPassed(_sso.invoicingmonth) == false) return false;
        if(this.isManfMonthFilterPassed(_sso.manufacturingMonth) == false) return false;
        if(this.isManfStrategyFilterPassed(_sso.manufacturingStrategy) == false) return false;
        if(this.isRelayConfigFilterPassed(_sso.relayconfig) ==false) return false;
  
        if(this.isPRFilterPassed(this.HOMFilter,_sso.parentSORef.marketingIP.homDate)== false) return false;
        if(this.isPRFilterPassed(this.SldGtpFilter,_sso.enggDrawIP.sldgtpSubDate)== false) return false;
        if(this.isPRFilterPassed(this.GaCsFilter,_sso.enggDrawIP.gacsSubDate)== false) return false;
        if(this.isPRFilterPassed(this.SchemeFilter,_sso.enggDrawIP.schemeSubDate)== false) return false;
        if(this.isPRFilterPassed(this.MgaFilter,_sso.enggDrawIP.mgaSubDate)== false) return false;
        if(this.isPRFilterPassed(this.SldGaGtpFilter,_sso.enggDrawIP.sldGaGtpAprvlDate)== false) return false;
        if(this.isPRFilterPassed(this.LngLeadFilter,_sso.enggProcureIP.longleadRDate)== false) return false;
        if(this.isPRFilterPassed(this.FinDrgFilter,_sso.pmTechSubSalesOrder.fnCusDrgAprvlDate)== false) return false;
        if(this.isPRFilterPassed(this.CtTechFilter,_sso.enggDrawIP.techCTDetsDate)== false) return false;
        if(this.isPRFilterPassed(this.FcmCTFilter,_sso.pmTechSubSalesOrder.fcmCTfinActDate)== false) return false;
        // if(this.isPRFilterPassed(this.CtFinalFilter,_sso.scmIP.CTfinSCMActDate)== false) return false;
        if(this.isPRFilterPassed(this.C40Filter,_sso.enggProcureIP.c40ActDate)== false) return false;
        if(this.isPRFilterPassed(this.C50Filter,_sso.enggProcureIP.c50ActDate)== false) return false;
        if(this.isPRFilterPassed(this.C60Filter,_sso.enggProcureIP.c60ActDate)== false) return false;
        if(this.isPRFilterPassed(this.RelayRcptFilter,_sso.purchaseMatReceipt.relayRecpDate)== false) return false;
        // if(this.isPRFilterPassed(this.CtRcptFilter,_sso.purchaseMatReceipt.ctRecpDate)== false) return false;
        // if(this.isPRFilterPassed(this.MbRcptFilter,_sso.purchaseMatReceipt.mbRecpDate)== false) return false;
        // if(this.isPRFilterPassed(this.LineLdngFilter,_sso.productionIP.lineLoadActDate)== false) return false;
        if(this.isPRFilterPassed(this.CbRcptFilter,_sso.purchaseMatReceipt.cbRecpDate)== false) return false;
        if(this.isPRFilterPassed(this.MechStkrFilter,_sso.productionIP.mechStickerDate)== false) return false;
        if(this.isPRFilterPassed(this.IntrnlTstFilter,_sso.qualityIP.elecMechTestingDate)== false) return false;
        if(this.isPRFilterPassed(this.FATFilter,_sso.qualityIP.FATDate)== false) return false;
        if(this.isPRFilterPassed(this.GreenStkrFilter,_sso.qualityIP.greenStickerDate)== false) return false;
        if(this.isPRFilterPassed(this.ExWrksFilter,_sso.pmTechSubSalesOrder.exWorksDate)== false) return false;

        //check serial no in search
        if (this.isSSOSerialNoSearchPassed(_sso.serialNos, this.serialSearch1) == false) return false;

        return true;
      });
    }

    private isPRFilterPassed(_selFilter:number,_data:string){
      _selFilter = parseInt(_selFilter + '', 10);     
      if(_selFilter != filterOptionPR.All){
        //check for failure cases
        switch (_selFilter) {
          case filterOptionPR.Complete:
            if(_data == null ) return false;
          break;
          case filterOptionPR.Pending:
            if(_data != null) return false;
          break;
        }
      }
      return true;
    }

    private isPRFilterPassed_LineLd(_filter:string,_data:string,_status:string){
        //check for failure cases
        switch (_filter) {
          case "1":
            if(_data != null && _status != "yellow") return true;
          break;
          case "2":
            if(_data == null && _status != "yellow") return true;
          break;
          case "3":
            if(_status == "yellow") return true;
          break;
        }
      
      return false;
    }

  private isPRFilterPassed_CTRcpt(_filter:string,_data:string,_status:string,_applicStatus:boolean){
      //check for failure cases
      switch (_filter) {
        case "1":
          if(_data != null && _status != "yellow" && _applicStatus == true) return true;
        break;
        case "2":
          if(_data == null && _status != "yellow" && _applicStatus == true) return true;
        break;
        case "3":
          if(_status == "yellow" && _applicStatus == true) return true;
        break;
        case "4":
          if(_applicStatus == false) return true;
        break;
      }
    
    return false;
  }

    private isPRFilterPassed_CTfinal(_data:string,_status:boolean){
      //check for failure cases
      switch (this.CtFinalFilter) {
        case "1":
          if(_data != null ) return true;
        break;
        case "2":
          if(_data == null && _status != false) return true;
        break;
        case "4":
          if(_status == false) return true;
        break;
      }
    
    return false;
  }

 private isPRFilterPassed_MBRecpt(_data:string,_status:string){
      //check for failure cases
      switch (this.MbRcptFilter) {
        case "1":
          if(_data != null ) return true;
        break;
        case "2":
          if(_data == null && _status != "NA") return true;
        break;
        case "4":
          if(_status == "NA") return true;
        break;
      }
    
    return false;
  }

    onComChange(_eventCom,_ssoNo) {
      this._comnts = _eventCom.target.value;    
      // console.log("this._eventCom",_eventCom);
      // console.log("this._eventCom value d ",_eventCom.value._d);
      this._SSoNo = _ssoNo;
      // console.log("this._ssoNo",_ssoNo);
    }

    // edit_row(ssoN){
    //   console.log("ssoN",ssoN);
    // }
    // edit_row(_evnt: Event, _ssoN: string){
    //   edit_row(_soId:string,_ssoN: string){
    //   let comm:CommentsPR = new CommentsPR("");
    //   let dialogRef = this.dialog.open(CommentsDialog,{ 
    //     width: 250 + 'px',
    //     data: comm
    //   });
    //   dialogRef.afterClosed().subscribe((confirm) => {
        
    //     //this.soObj.changeCounter = this.soObj.changeCounter +1;
    //     if (confirm == true) {
    //       this.filteredSaleOrderArray1.filter(val=> {
    //         if( _soId == val.soId && _ssoN == val.ssoNo){
    //         //  val.commentsPR = "_ssoN"+comm.comments;
    //          this.pmTechSSO.commentsPR = "_ssoN"+comm.comments;
    //         }
    //        });
    //       // if(preExecStep != null) {
    //       //   preExecStep();
    //       // }
    //       // this._dataService.deleteSalesOrder(this.soObj, delReason.comments).subscribe((_result:boolean) => {
    //       //   if (_result == true) {
    //       //     this._dataService.openSnackbar("Status", "SUCCESS");
  
    //       //     setTimeout(() => {
    //       //       this.router.navigate(["/"])  
    //       //     }, 500);
    //       //     //this.loadSalesOrderData();
    //       //   }
    //       //   else
    //       //     this._dataService.openSnackbar("Status", "FAILED");
    //       // });
    //     }
    //     else {
    //       //user didn't accepted
    //     }
    //   });
    // }

    private isDaysReqFiltered(_days:string):boolean{
      let _daysNum = parseInt(_days,10);
      switch (this.DaysReqFilter) {

        case "1"://Greater than 10
          if (_daysNum > 10) return true;
          break;
        case "2"://Lesser Than 0
          if ( _daysNum < 0) return true;
          break;
        case "3"://0 - 10
          if (_daysNum >= 0 && _daysNum <= 10) return true;
          break;

      }
      return false;
  }

    private isQuantityTypeMatching(_panelQty:number):boolean{
        switch (this.quantityTypeId1) {
          
          // case "1"://0-10
          //   // if (_panelQty >= 0 && _panelQty <= 10) return true;
          //   if (_panelQty >= 1 && _panelQty <= 10) return true;
          //   break;
          // case "2"://11-20
          //   if (_panelQty >= 11 && _panelQty <= 20) return true;
          //   break;
          // case "3"://21-50
          //   if (_panelQty >= 21 && _panelQty <= 50) return true;
          //   break;
          // case "4"://51-100
          //   if (_panelQty >= 51 && _panelQty <= 100) return true;
          //   break;
          // case "5"://100+
          //   if (_panelQty > 100) return true;
          //   break;

          case "1":// Non zero
            // if (_panelQty >= 0 && _panelQty <= 10) return true;
            if (_panelQty >= 1) return true;
            break;
          case "2"://0-10
            // if (_panelQty >= 0 && _panelQty <= 10) return true;
            if (_panelQty >= 1 && _panelQty <= 10) return true;
            break;
          case "3"://11-20
            if (_panelQty >= 11 && _panelQty <= 20) return true;
            break;
          case "4"://21-50
            if (_panelQty >= 21 && _panelQty <= 50) return true;
            break;
          case "5"://51-100
            if (_panelQty >= 51 && _panelQty <= 100) return true;
            break;
          case "6"://100+
            if (_panelQty > 100) return true;
            break;
         

        }
        return false;
    }
  
    private isSONoCustSearchPassed(_soNo:string, _custName:string, 
                                   _isSoNoUpdated:boolean, _newSoNumber:string, 
                                   _srchText:string):boolean{
  
      if(_srchText != ''){
        _srchText = _srchText.toLowerCase();
        if (_soNo && (_soNo + '').toLowerCase().indexOf(_srchText) >= 0) {
          return true;
        }
        if (_isSoNoUpdated == true && _newSoNumber && (_newSoNumber + '').toLowerCase().indexOf(_srchText) >= 0) {
          return true;
        }
        if (_custName && _custName.toLowerCase().indexOf(_srchText) >= 0){
          return true;
        }
        return false;
      }
      
      return true;
    }
    private isSSOSerialNoSearchPassed(_serialNo: Array<string>,
      _srchText: string): boolean {
        
      if (_srchText != '') {
        _srchText = _srchText.toLowerCase();
        const indexSerial = _serialNo.findIndex(element => {
          if (element.includes(_srchText)) {
            return true;
          }
        });
        if (indexSerial !== -1){
          return true;
        }
        return false;
      }
  
      return true;
    }
  
    private isRevMonthFilterPassed(_revenueMonth:Date){
      if(this.isRevMonthFilterSelected1 == true && this.revMonthFilter1 != null){
          if(this.revMonthFilter1.isWithInFilterScope(_revenueMonth) == false) {
            return false;
          }
      }
      return true;
    }
    private isInvMonthFilterPassed(_invoicingmonth:Date){
      if(this.isInvMonthFilterSelected1 == true && this.InvMonthFilter1 != null){
          if(this.InvMonthFilter1.isWithInFilterScope(_invoicingmonth) == false) {
            return false;
          }
      }
      return true;
    }
    private isManfMonthFilterPassed(_manfMonth:Date){
      if(this.isManfMonthFilterSelected1 == true && this.manfMonthFilter1 != null){
          if(this.manfMonthFilter1.isWithInFilterScope(_manfMonth) == false) {
            return false;
          }
      }
      return true;
    }
    private isManfStrategyFilterPassed(_manfStraId:string){
      if(this.isManfStrategyFilterSelected1 == true && 
         this.manfStrategyIndex1 >= 0 && this._dataService1.manufacturtingStrategy[this.manfStrategyIndex1]){
  
          if(this._dataService1.manufacturtingStrategy[this.manfStrategyIndex1].manufacturtingStrategyId != _manfStraId) {
            return false;
          }
  
      }
      return true;
    }
    private isOrderTypeFilterPassed(_ordertypeId: string){
      if(this.isOrderTypeFilterSelected1 == true && this.orderTypeIndex1 >= 0 && this._dataService1.ordertypes[this.orderTypeIndex1]){
        if(this._dataService1.ordertypes[this.orderTypeIndex1].ordertypeId != _ordertypeId){
          return false
        }
      }
      return true;
    }
    private isRelayConfigFilterPassed(_relayconfigId: string){
      if(this.isRelayConfigFilterSelected1 == true && this.relayConfigIndex1 >= 0 && this._dataService1.relayconfigs_ui[this.relayConfigIndex1]){
        if(this._dataService1.relayconfigs_ui[this.relayConfigIndex1].relayconfigId != _relayconfigId){
          return false
        }
      }
      return true;
    }
    private isRegionFilterPassed(_regionId: string){
      //this.regionIndex1-1 is because the array index needs to match with the _regionId
      if(this.isRegionFilterSelected1 == true && (this.regionIndex1-1) >= 0 && this._dataService1.regions[this.regionIndex1-1]){
        if(this._dataService1.regions[this.regionIndex1-1].regionId != _regionId){
          return false
        }
      }
      return true;
    }
  
    private isSOUserFilterPassed(_mktgEngId:string, _projManagerId:string, _projEngId:string):boolean{
      //check for failure cases
      if(this.isUserSelectionFilterSelected1 == true && !this.userTypeArray1.includes(userFilterOption.All)){
        if(this.userTypeArray1.includes(userFilterOption.MarketingEngineer)){
          if(!this.marketingEnggArray1.includes(_mktgEngId)) return false;
        }
        else if(this.userTypeArray1.includes(userFilterOption.ProjectManager)){
          if(!this.projManagerArray1.includes(_projManagerId)) return false;
        }
        else if(this.userTypeArray1.includes(userFilterOption.ProjectEngineer)){
          if(!this.projEnggArray1.includes(_projEngId)) return false;
        }
      }
      return true;
    }
    private isSSOUserFilterPassed(_elecEngId:string, _mechEnggId:string, _c30EngId:string):boolean{
      //check for failure cases
      if(this.isUserSelectionFilterSelected1 == true && !this.userTypeArray1.includes(userFilterOption.All)){
        if(this.userTypeArray1.includes(userFilterOption.ElectricDesignEngineer)){
          if(!this.elecDesignEnggArray1.includes(_elecEngId)) return false;
        }
        else if(this.userTypeArray1.includes(userFilterOption.MechanicalDesignEngineer)){
          if(!this.mechDesignEnggArray1.includes(_mechEnggId)) return false;
        }
        else if(this.userTypeArray1.includes(userFilterOption.C30Engineer)){
          if(!this.c30EnggArray1.includes(_c30EngId)) return false;
        }
      }
      return true;
    }
    exportToExcel(){
  
      // this._dataObj1 = JSON.stringify(this.prepareDownloadObj());
  
      // setTimeout(() => {
      //   this.userImpFrm.nativeElement.submit()  
      // }, 10);
  
      console.log('exportToExcel');
    }
  
    prepareDownloadObj(){
      var _json = {};
      
      return _json;
    }
    exportasexcel(){
      let element = document.getElementById('excel-table');
      // console.log("document.getElementById('excel-table')",document.getElementById('excel-table'));
      
      //To remove the titles for the export of the excel
      let arr = document.getElementsByClassName('table');
      
      for (var i = 0; i < arr.length; i++) {
  
        var t_temp = arr[i].children[0].children[2] //thead reference for appending it later
  
        // Remove the filters values from the excel export
        var t = arr[i].children[0].children[2] //thead reference
        t.remove();
        
      //   // Remove the title(tooltips) from the excel export
      //   var b = arr[i].children[1] //tbody reference
      //   var d = b.getElementsByTagName('div');
      //   var len = d.length
      //   for (var i = 0; i < len; i++) {
      //     if (d.item(i).hasAttribute("title")) {
      //       d.item(i).removeAttribute("title");
      //     }
      //   }
      }
        //Export to excel
        const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element, { cellDates:true,dateNF:'mm/dd/yyyy;@',
          raw: false
        });//converts a DOM TABLE element to a worksheet      
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        ws['!merges'][0].e.c = 6; // This merges the Proj Engg and the Design Engg columns in excel
        /* save to file */
        XLSX.writeFile(wb, 'proj_review_gantt.xlsx');
  
        // Append the filters after export
        let arr1 = document.getElementsByClassName('table');
        for (var i = 0; i < arr1.length; i++) {
    
          // Append the filters values from the excel export
        var t1 = arr1[i].children[0]; //thead parent reference      
        t1.appendChild(t_temp); 
  
        }
        this.reloadData();
    }
  
    minrFunc(){
      this.filteredCustPOVal1 = this.filteredCustPOVal1_temp;
      this.filteredAmmendPOVal1 = this.filteredAmmendPOVal1_temp;
      this.filteredPOValue1 = this.filteredPOValue1_temp;
      this.unitName = "minr";
      
    }
    tinrFunc(){
      this.filteredCustPOVal1 = this.filteredCustPOVal1_temp/1000;
      this.filteredAmmendPOVal1 = this.filteredAmmendPOVal1_temp/1000;
      this.filteredPOValue1 = this.filteredPOValue1_temp/1000;
      this.unitName = "tinr";
      
    }
    musdFunc(){
      this.filteredCustPOVal1 = this.filteredCustPOVal1_temp*0.0133;
      this.filteredAmmendPOVal1 = this.filteredAmmendPOVal1_temp*0.0133;
      this.filteredPOValue1 = this.filteredPOValue1_temp*0.0133;
      this.unitName = "musd";
      
    }
  }
  
  
  export enum filterOption{
    All = 0,
    Delay = -1,
    Early = 1,
    NotStarted = 2,
    Pending = 6, 
    Partial = 3,
    Waiting = 4,
    Complete = 5,
    Relay_pending = 8
  }

export enum filterOptionPR{
    All = 0,
    Complete = 1,
    Pending = 2,
    NotStarted = 3,
    NotApplicable = 4

}